import { io, Socket } from "socket.io-client"

export class SocketClient {
  private static readonly RECONNECTION_DELAY_MS = 1000
  private static readonly RECONNECTION_DELAY_MAX_MS = 5000
  private static readonly RECONNECTION_ATTEMPTS = Infinity

  private static socket: Socket | null = null
  private static connectionListeners: Array<(connected: boolean) => void> = []

  public static initialize = (): void => {
    if (SocketClient.socket) return

    const socket = io({
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: SocketClient.RECONNECTION_ATTEMPTS,
      reconnectionDelay: SocketClient.RECONNECTION_DELAY_MS,
      reconnectionDelayMax: SocketClient.RECONNECTION_DELAY_MAX_MS,
    })
    SocketClient.socket = socket

    socket.on("connect", () => SocketClient.notifyConnectionChange(true))
    socket.on("disconnect", (reason) => {
      SocketClient.notifyConnectionChange(false)
      if (reason === "io server disconnect") {
        // Reconnect
        socket.connect()
      }
    })
  }

  public static on = (event: string, callback: (...args: any[]) => void): void => {
    SocketClient.socket?.on(event, callback)
  }

  public static off = (event: string, callback?: (...args: any[]) => void): void => {
    SocketClient.socket?.off(event, callback)
  }

  public static emit = (event: string, data?: any): void => {
    SocketClient.socket?.emit(event, data)
  }

  public static isConnected = (): boolean => SocketClient.socket?.connected ?? false

  public static onConnectionChange = (callback: (connected: boolean) => void): void => {
    SocketClient.connectionListeners.push(callback)
  }

  public static offConnectionChange = (callback: (connected: boolean) => void): void => {
    SocketClient.connectionListeners = SocketClient.connectionListeners.filter((listener) => listener !== callback)
  }

  private static notifyConnectionChange = (connected: boolean): void => {
    for (const listener of SocketClient.connectionListeners) {
      listener(connected)
    }
  }
}
